import { ReactElement } from 'react';
import { Box, alpha } from '@mui/material';
import { DataGridToolbarActions } from 'components/common/dataGrid/DataGridToolbarActions';
import { InspectionStateToggle } from './InspectionStateToggle';

interface InspectionToolbarProps {
  SearchInput: () => ReactElement;
}

export function InspectionToolbar({
  SearchInput,
}: InspectionToolbarProps): ReactElement {
  return (
    <Box
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: (theme) => `0px 2px 4px ${alpha(theme.palette.common.black, 0.05)}`,
        zIndex: 1,
        paddingLeft: '20px',
        paddingRight: '20px',
        gap: '16px',
      }}
    >
      <SearchInput />
      <DataGridToolbarActions
        columnsDataQa='inspection-table-column-settings-button'
        afterColumns={<InspectionStateToggle />}
      />
    </Box>
  );
}
